import { jsx as l, jsxs as m } from "react/jsx-runtime";
import { forwardRef as v, useRef as h, useState as g, useEffect as u } from "react";
import s from "./styles.module.less.js";
const I = v(
  (t, f) => {
    var c;
    const i = h([]), n = t.options.findIndex(
      (e) => e.id === t.activeId
    ), [a, o] = g(0);
    return u(() => {
      var d;
      const e = (d = i.current[n]) == null ? void 0 : d.clientWidth;
      o(e);
    }, [n]), /* @__PURE__ */ l(
      "div",
      {
        ref: f,
        ...t.props,
        className: `${s.segmentedControl} ${(c = t.props) == null ? void 0 : c.className}`,
        children: /* @__PURE__ */ m("div", { className: s.segments, children: [
          /* @__PURE__ */ l(
            "div",
            {
              className: s.slidingBackground,
              style: {
                width: a,
                transform: `translateX(${a * n}px)`
              }
            }
          ),
          t.options.map((e, d) => /* @__PURE__ */ m(
            "div",
            {
              className: `${s.segment} ${t.activeId === e.id ? s.active : ""}`,
              onClick: () => !t.disabled && t.onChange(e.id),
              ref: (r) => {
                r && (i.current[d] = r);
              },
              children: [
                e.label,
                t.activeId === e.id && e.hoverIcon ? e.hoverIcon : e.icon
              ]
            },
            e.id
          ))
        ] })
      }
    );
  }
);
I.displayName = "SegmentedControl";
export {
  I as SegmentedControl
};
